import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SupportListItem } from 'src/app/common/models/support/SupportListItem';
import { SupportThread } from 'src/app/common/models/support/SupportThread';
import { SupportMessage } from 'src/app/common/models/support/SupportMessage';
import { SupportCloseResult } from 'src/app/common/models/support/SupportThread';

@Injectable({
  providedIn: 'root'
})
export class SupportCasesApiService {
  private readonly apiDomain = environment.API_URL_CORE;
  private readonly baseUrl = `${this.apiDomain}/api/support`;

  constructor(private http: HttpClient) { }

  public getOwnCases(): Observable<SupportListItem[]> {
    return this.http.get<SupportListItem[]>(this.baseUrl);
  }

  public createCase(topic: string, message: string): Observable<{ supportId: string }> {
    return this.http.post<{ supportId: string }>(this.baseUrl, { topic, message });
  }

  public getThread(supportId: string): Observable<SupportThread> {
    return this.http.get<SupportThread>(`${this.baseUrl}/${supportId}`);
  }

  public postReply(supportId: string, message: string): Observable<SupportMessage> {
    return this.http.post<SupportMessage>(`${this.baseUrl}/${supportId}/reply`, { message });
  }

  public close(supportId: string, rating: number): Observable<SupportCloseResult> {
    return this.http.post<SupportCloseResult>(`${this.baseUrl}/${supportId}/close`, { rating });
  }
}
